const ImagePreviewer = (props) => (
    <img src={props.url} width={props.width || 100} height={props.height || 100} />
)

export default ImagePreviewer;